<template>
	<div>
		<carbon-ads placement="InboxKittenLanding"></carbon-ads>
		<div class="kittenrouter-navigation">
			<img class="kittenrouter-nav-main-logo" src="@/assets/inbox_kitten.png" @click="goToMainPage"/>
		</div>
		<div class="header-gradient-background">
			<div class="header">
			</div>
		</div>
		<div class="info-guide">
			<div class="features">
                <div class="feature-card"></div>
                <div class="feature-card feature-card-hover">
                    <a href="https://github.com/uilicious/kittenrouter" target="_blank" style="text-decoration: none; color: inherit; cursor: pointer;">
                        <h2> Check out Kitten Router at Github to find out more! </h2>
<pre class="hljs" style="display: block; overflow-x: auto; padding: 0.5em; background: rgb(240, 240, 240); color: rgb(68, 68, 68);"><span>https://github.com/uilicious/kittenrouter</span></pre>
                    </a>
                </div>
                <div class="feature-card"></div>
			</div>
		</div>
        <div class="line-break"></div>
		<div class="love-notes">
			<p>
				made with <span style="color: #e25555;">&hearts;</span> by <a href="https://uilicious.com">uilicious</a> in <a href="https://www.google.com.sg/search?q=singapore">Singapore</a>
			</p>
		</div>
    </div>
</template>

<script>
import shareConfig from '@/../config/shareConfig.js'

export default {
	name: 'App',
	data: () => {
		return {
			mainURL: shareConfig.mainURL
		}
    },
    mounted () {
        document.getElementsByClassName('github-corner')[0].href = 'https://github.com/uilicious/kittenrouter'
	},
	methods: {
		goToMainPage () {
			location.href = this.mainURL
		}
	}
}
</script>

<style lang="scss" rel="stylesheet/scss">
	@import url("https://use.fontawesome.com/releases/v5.3.1/css/all.css");
    @import "scss/landingpage.scss";

	.kittenrouter-navigation {
		display:flex;
		justify-content: flex-end;
		align-items: center;
		float:right;
		width: 100vw;
		height: 1rem;
		text-align: left;

		.kittenrouter-nav-main-logo {
			width:8rem;
			padding-top:7rem;
			padding-right: 4rem;
			z-index: 2;
			cursor: pointer;
		}

		.kittenrouter-nav-header {
			padding-top:6rem;
			padding-right: 3rem;
			cursor: pointer;
		}
	}

	@media only screen and (max-width:470px) {
		.kittenrouter-navigation .kittenrouter-nav-main-logo {
			padding-right: 4rem;
			width:5rem;
			z-index: 3;
		}
		.kittenrouter-nav-header {
			display: none;
		}
	}

	@media only screen and (max-width: 800px) {
		.kittenrouter-navigation {
			padding-top: 140px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/kittenrouter.vue